import { validate } from '../../Input/utils';
export const validateItemErrors = (item, definitions) => {
    let errors = [];
    const itemKeys = definitions.map((def) => def.name);
    itemKeys.forEach((key) => {
        var _a;
        const errorMsg = validate(item[key] || '', (_a = definitions.find((d) => d.name === key)) === null || _a === void 0 ? void 0 : _a.validation);
        if (errorMsg) {
            errors.push({ [key]: errorMsg });
        }
    });
    return errors.length > 0 ? errors : null;
};
